import { unFormatCurrency, unFormatUnknownUnit } from "@/common/utils/unFormatters";
import {
  GovernmentAllocationProductDistributionValidationSchema,
  GovernmentAllocationProductDistributionQuantityValidationSchema,
} from "@/features/privateCompanies/schemas/createGovernmentAllocationDistribution.schema";

export const transformNewProductDistribution = (formProduct: GovernmentAllocationProductDistributionValidationSchema) => {
  return {
    product_id: formProduct.product.id,
    total_value: formProduct.total_value ? unFormatCurrency(formProduct.total_value) : 0,
  };
};

export const transformUpdatedProductDistribution = (formProduct: GovernmentAllocationProductDistributionValidationSchema) => {
  const { product_id, ...transformedProductDistribution } = transformNewProductDistribution(formProduct);

  return {
    id: formProduct.id,
    ...transformedProductDistribution,
  };
};

export const transformNewProductDistributionQuantity = (formProduct: GovernmentAllocationProductDistributionQuantityValidationSchema) => {
  return {
    product_id: formProduct.product.id,
    total_quantity: formProduct.total_quantity
      ? unFormatUnknownUnit(formProduct.total_quantity) >= 0
        ? unFormatUnknownUnit(formProduct.total_quantity)
        : undefined
      : 0,
  };
};

export const transformUpdatedProductDistributionQuantity = (formProduct: GovernmentAllocationProductDistributionQuantityValidationSchema) => {
  const { product_id, ...transformedProductDistribution } = transformNewProductDistributionQuantity(formProduct);

  return {
    id: formProduct.id,
    ...transformedProductDistribution,
  };
};
